export const STORE_ACTIONS = {
  REQUESTED: 'store/requested',
  SUCCEEDED: 'store/succeeded',
  FAILED: 'store/failed',
};

export const SAVE_REQUEST_ACTIONS = {
  REQUESTED: 'save/request/requested',
  SUCCEEDED: 'save/request/succeeded',
  FAILED: 'save/request/failed',
};

export const UPDATE_COMMENT = 'store/UPDATE_COMMENT';
export const UPDATE_COMMENT_SUCCESS = 'store/UPDATE_COMMENT_SUCCESS';

export interface StoreSucceeded {
  type: string;
  payload: { store: any };
}

export interface CommentSuccess {
  type: string;
  payload: { comment: string };
}

export const storeSucceeded = (store: any): StoreSucceeded => ({
  type: STORE_ACTIONS.SUCCEEDED,
  payload: { store },
});

export const commentUpdateSuccess = (comment: string): CommentSuccess => ({
  type: UPDATE_COMMENT_SUCCESS,
  payload: { comment },
});

export interface StoreRequested {
  type: string;
  payload: { storeId: string };
}

export const storeRequested = (storeId: string): StoreRequested => ({
  type: STORE_ACTIONS.REQUESTED,
  payload: { storeId },
});

export interface StoreFailed {
  type: string;
  error: string;
}

export const storeFailed = (error: string) => ({
  error,
  type: STORE_ACTIONS.FAILED,
});

export const saveRequestRequested = (request: any, collections: any[]) => ({
  type: SAVE_REQUEST_ACTIONS.REQUESTED,
  payload: { request, collections },
});

export const updateComment = (storeId: string, comment: string) => ({
  type: UPDATE_COMMENT,
  payload: { storeId, comment },
});

export const saveRequestSucceeded = () => ({
  type: SAVE_REQUEST_ACTIONS.SUCCEEDED,
});

export const saveRequestFailed = (error: any) => ({
  error,
  type: SAVE_REQUEST_ACTIONS.FAILED,
});

export type CitiesAction =
  | StoreRequested
  | StoreSucceeded
  | StoreFailed
  | CommentSuccess;



// WEBPACK FOOTER //
// ./src/scenes/Store/services/actions.ts